import { useMemo } from 'react';
import { useAppFilterSelectedValue } from '../../../hooks/filters/use-app-filter-selected-value.hook';
import { useFilterContext } from '../provider/filter.provider';
import {
  useAppSimpleFilterSelectedValue,
  useFilterSelectionMemoFor,
  useFullFilterSelectionMemo,
} from './common.hook';
import { FILTER_NAMES } from './filter-names.constants';

export const useFilterPanelSelection = () => {
  // Filters can vary accoding to the module/page selected.
  const filters = useFilterContext();
  const including = useMemo(() => {
    return filters.map((i) => i.id);
  }, [filters]);
  // Some filters like categorySingle and MarkeyMulti can be neccessary or not. We use the filters in the context to determine what filter selection is needed.
  const filterSelection = useFilterSelectionMemoFor(
    including,
    useAppSimpleFilterSelectedValue(FILTER_NAMES.DATE),
    useAppSimpleFilterSelectedValue(FILTER_NAMES.METACATEGORY),
    useAppSimpleFilterSelectedValue(FILTER_NAMES.CATEGORY),
    useAppSimpleFilterSelectedValue(FILTER_NAMES.CATEGORYSINGLE),
    useAppSimpleFilterSelectedValue(FILTER_NAMES.BRAND),
    useAppSimpleFilterSelectedValue(FILTER_NAMES.SUBBRAND),
    useAppSimpleFilterSelectedValue(FILTER_NAMES.SIZEGROUP),
    useAppSimpleFilterSelectedValue(FILTER_NAMES.PPG),
    useAppSimpleFilterSelectedValue(FILTER_NAMES.UPC),
    useAppSimpleFilterSelectedValue(FILTER_NAMES.SUBPPG),

    useAppSimpleFilterSelectedValue(FILTER_NAMES.MARKET),
    useAppSimpleFilterSelectedValue(FILTER_NAMES.MARKETMULTI),
    useAppSimpleFilterSelectedValue(FILTER_NAMES.DATEHIER),
    useAppSimpleFilterSelectedValue(FILTER_NAMES.MEASUREHIER),
  );

  return filterSelection;
};

export const useFilterSelectionToReset = () => {
  const date = useAppFilterSelectedValue(FILTER_NAMES.DATE);
  // const metaCategory = useAppFilterSelectedValue(FILTER_NAMES.METACATEGORY)
  const category = useAppFilterSelectedValue(FILTER_NAMES.CATEGORY);
  const categorySingle = useAppFilterSelectedValue(FILTER_NAMES.CATEGORYSINGLE);
  const brand = useAppFilterSelectedValue(FILTER_NAMES.BRAND);
  const subBrand = useAppFilterSelectedValue(FILTER_NAMES.SUBBRAND);
  const sizeGroup = useAppFilterSelectedValue(FILTER_NAMES.SIZEGROUP);
  const ppg = useAppFilterSelectedValue(FILTER_NAMES.PPG);
  const subPpg = useAppFilterSelectedValue(FILTER_NAMES.SUBPPG);
  const upc = useAppFilterSelectedValue(FILTER_NAMES.UPC);
  const prodHier = useAppFilterSelectedValue(FILTER_NAMES.PRODUCTHIER);

  const variableCompBrand = useAppFilterSelectedValue(
    FILTER_NAMES.VARIABLECOMPBRAND,
  );
  const variableGroup = useAppFilterSelectedValue(FILTER_NAMES.VARIABLEGROUP);
  const periodLength = useAppFilterSelectedValue(FILTER_NAMES.PERIODLENGTH);
  const datePrev = useAppFilterSelectedValue(FILTER_NAMES.DATEPREV);
  const datePost = useAppFilterSelectedValue(FILTER_NAMES.DATEPOST);

  const categoryDt = useAppFilterSelectedValue(
    FILTER_NAMES.CATEGORY_DRILLTHROUGH,
  );
  const brandDt = useAppFilterSelectedValue(FILTER_NAMES.BRAND_DRILLTHROUGH);
  const subBrandDt = useAppFilterSelectedValue(
    FILTER_NAMES.SUBBRAND_DRILLTHROUGH,
  );
  const sizeGroupDt = useAppFilterSelectedValue(
    FILTER_NAMES.SIZEGROUP_DRILLTHROUGH,
  );
  const ppgDt = useAppFilterSelectedValue(FILTER_NAMES.PPG_DRILLTHROUGH);

  const filterSetSelection = useFullFilterSelectionMemo(
    date,
    // market,
    // metaCategory,
    category,
    categorySingle,
    brand,
    subBrand,
    sizeGroup,
    ppg,

    subPpg,
    upc,
    prodHier,
    categoryDt,
    brandDt,
    subBrandDt,
    sizeGroupDt,
    ppgDt,
    variableCompBrand,
    variableGroup,
    periodLength,
    datePrev,
    datePost,
  );
  return filterSetSelection;
};

export const useFilterSelectionDateToReset = () => {
  const date = useAppFilterSelectedValue(FILTER_NAMES.DATE);
  const periodLength = useAppFilterSelectedValue(FILTER_NAMES.PERIODLENGTH);
  const datePrev = useAppFilterSelectedValue(FILTER_NAMES.DATEPREV);
  const datePost = useAppFilterSelectedValue(FILTER_NAMES.DATEPOST);
  const filterSetSelection = useFullFilterSelectionMemo(
    date,
    periodLength,
    datePrev,
    datePost,
  );
  return filterSetSelection;
};
